import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { quoteFormSelector } from 'ctm-selectors';
import { SummaryTable } from '../summary_table';
import { spacingContactNumber } from '../../products/summary/common/beautify_contact_number';

const path = 'applicant_details';

const _SummaryContactDetails = (props) => {
    const { email, firstName, lastName, contactNumber, isUpdated } = props;

    const contactDetails = [
        {
            title: 'Name',
            value: `${firstName} ${lastName}`
        },
        {
            title: 'Phone',
            value: contactNumber ? spacingContactNumber(contactNumber) : 'None'
        },
        {
            title: 'Email',
            value: email
        }
    ];

    return (
        <SummaryTable
            isUpdated={isUpdated}
            path={path}
            titleLabel={`Contact Details ${isUpdated ? '- Updated' : ''}`}
            tableContent={contactDetails}
        />
    );
};

const mapStateToProps = (state) => {
    const mobile = quoteFormSelector(state).getIn(['applicant', 'mobile']);
    const phone = quoteFormSelector(state).getIn(['applicant', 'phone']);
    return {
        firstName: quoteFormSelector(state).getIn(['applicant', 'firstName']) || '',
        lastName: quoteFormSelector(state).getIn(['applicant', 'lastName']) || '',
        email: quoteFormSelector(state).getIn(['applicant', 'email']),
        contactNumber: mobile || phone,
        isUpdated: state.getIn(['vertical', 'quote', 'form', `summaryPageEdit${path}`])
    };
};

_SummaryContactDetails.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    isUpdated: PropTypes.bool
};

const SummaryContactDetails = connect(
    mapStateToProps,
)(_SummaryContactDetails);

export { _SummaryContactDetails, SummaryContactDetails };
